<p>Chapters:</p>
<div class="chapters" *ngFor="let chapter of chapterList">
  <div class="u-font-weight-700">{{chapter.title}}</div>
  <div class="chapters__description">{{chapter.description}}</div>
</div>
